import axios from "axios";

// 创建 axios 实例
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "https://api.vdoge.me",
  timeout: 30000,  // 请求超时时间
});

// API 函数
export const analyzeAddresses = async (addresses) => {
  const resp = await api.post("/analyze", { addresses });
  return resp.data.results;
};

export const analyzeSingleAddress = async (address, remark) => {
  const resp = await api.post("/analyze/single", { address, remark });
  return resp.data;
};

export const retryFailedAddresses = async (failedAddresses) => {
  const resp = await api.post("/analyze/retry", { failed_addresses: failedAddresses });
  return resp.data;
}; 